var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-box",class:{
    'video-chat':
      ((_vm.activeVideo || _vm.isVideoChat) && _vm.collocutorCameraOn) ||
      _vm.collocutorCameraOn,
  }},[_c('woman-left-side',{staticClass:"grid-left-sidebar"}),_c('ChatBox',{staticClass:"grid-chat-box"}),_c('woman-right-side',{staticClass:"grid-right-sidebar"}),_c('gallery'),_c('mail-modal'),_c('virtual-gifts-modal'),_c('get-user-media-modal'),_c('bad-connection-modal'),_c('duplicate-user-media-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }